"use strict"

angular.module("customer")
.service("DepositSlipService", function($resource, FlashBag, appConfig) {
    var resource = $resource(appConfig.API_SERVER + "/sales-representatives/deposit-slip/", {}, {
        query: {
            method: "GET",
            interceptor: {responseError: FlashBag.responseErrorInterceptor}
        }, post: {
            method: "POST",
            interceptor: {responseError: FlashBag.responseErrorInterceptor}
        }
    });

    this.query = function(params) {
        return resource.query(params);
    };

    this.post = function(params) {
        return resource.post(params);
    };
});



//////////////////
// WEBPACK FOOTER
// ./customer/sections/deposit-slip/deposit-slip.service.js
// module id = 910
// module chunks = 0